export class CampanhaEnviarAnalise {
    aprovada: boolean;
    justificativaAnalise: string;

    constructor(aprovada: boolean) {
        this.aprovada = aprovada;
    }
}
